module.exports = __webpack_public_path__ + "static/personalizedcontent_icon-ef8541ddea83c573220e6799af2be12b.svg";